
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputLeft as ObiInputLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-left.js';
 
 
 

 
 export const ObiInputLeft = createComponent({
   react: React,
   tagName: 'obi-input-left',
   elementClass: ObiInputLeftElement,
   events: {
     
   }
  });
 
 